import styled from '@emotion/styled';
import facebookIcon from 'assets/facebookIcon.svg';
import instagramIcon from 'assets/instagramIcon.svg';
import linkedInIcon from 'assets/linkedInIcon.svg';
import whatsAppIcon from 'assets/whatsAppIcon.svg';
import React from 'react';
import { socialLinks } from 'src/config';
import { breakpoints, getMQ } from 'src/helpers';
import Analytics from 'src/helpers/analytics';

const SocialLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 0px;

  ${getMQ(breakpoints.m)} {
    margin: 0px;
    margin-top: 10px;
  }
`;

const FacebookIconStyled = styled(facebookIcon)`
  &:hover {
    opacity: 0.5;
  }
`;

const WhatsAppIconStyled = styled(whatsAppIcon)`
  margin-left: 24px;
  &:hover {
    opacity: 0.5;
  }
`;

const InstagramIconStyled = styled(instagramIcon)`
  margin-left: 24px;
  &:hover {
    opacity: 0.5;
  }
`;

const LinkedInIconStyled = styled(linkedInIcon)`
  margin-left: 24px;
  &:hover {
    opacity: 0.5;
  }
`;

const SocialLinks = () => {
  const onAppClick = (name: string) => {
    Analytics.logAppButtonClick(name);
  };

  return (
    <SocialLinksContainer>
      <a onClick={() => onAppClick('linkedin')} href={socialLinks.linkedin} target="_blank" rel="noreferrer">
        <LinkedInIconStyled />
      </a>
      <a onClick={() => onAppClick('whatsapp')} href={socialLinks.whatsapp} target="_blank" rel="noreferrer">
        <WhatsAppIconStyled />
      </a>
      <a onClick={() => onAppClick('instagram')} href={socialLinks.instagram} target="_blank" rel="noreferrer">
        <InstagramIconStyled />
      </a>
      <a onClick={() => onAppClick('facebook')} href={socialLinks.facebook} target="_blank" rel="noreferrer">
        <FacebookIconStyled />
      </a>
    </SocialLinksContainer>
  );
};

export default SocialLinks;
